import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { CommercialPage } from "@/features/reporting/components/commercial-page";
import { resolveCommercialPeriod } from "@/features/reporting/lib/period";

const layoutRoute = getRouteApi("/_authed/_dashboard/reporting");

export const Route = createFileRoute("/_authed/_dashboard/reporting/commercial")({
  component: ReportingCommercialRoute,
});

function ReportingCommercialRoute() {
  const search = layoutRoute.useSearch();

  // Pas de `tenantId` : les marts commerciaux ne portent que l'entreprise facturée.
  return <CommercialPage period={resolveCommercialPeriod(search.period)} companyId={search.companyId} />;
}
